"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "POPULAR", {
  enumerable: true,
  get: function get() {
    return _Collection.POPULAR;
  }
});
Object.defineProperty(exports, "NEW", {
  enumerable: true,
  get: function get() {
    return _Collection.NEW;
  }
});
Object.defineProperty(exports, "FOR_STARTUPS", {
  enumerable: true,
  get: function get() {
    return _Collection.FOR_STARTUPS;
  }
});
Object.defineProperty(exports, "FOR_AGENCIES", {
  enumerable: true,
  get: function get() {
    return _Collection.FOR_AGENCIES;
  }
});
Object.defineProperty(exports, "HOMEMADE", {
  enumerable: true,
  get: function get() {
    return _Collection.HOMEMADE;
  }
});
Object.defineProperty(exports, "PIESYNC", {
  enumerable: true,
  get: function get() {
    return _Collection.PIESYNC;
  }
});
Object.defineProperty(exports, "CMS", {
  enumerable: true,
  get: function get() {
    return _Collection.CMS;
  }
});
Object.defineProperty(exports, "ABM", {
  enumerable: true,
  get: function get() {
    return _Collection.ABM;
  }
});
exports.FOR_CUSTOMER_SUCCESS_TEAMS = exports.FOR_SALES_TEAMS = exports.FOR_MARKETING_TEAMS = exports.FREE = void 0;

var _Collection = require("ecosystem-marketplace-core/constants/search/Collection");

var FREE = 'FREE';
exports.FREE = FREE;
var FOR_MARKETING_TEAMS = 'FOR_MARKETING_TEAMS';
exports.FOR_MARKETING_TEAMS = FOR_MARKETING_TEAMS;
var FOR_SALES_TEAMS = 'FOR_SALES_TEAMS';
exports.FOR_SALES_TEAMS = FOR_SALES_TEAMS;
var FOR_CUSTOMER_SUCCESS_TEAMS = 'FOR_CUSTOMER_SUCCESS_TEAMS';
exports.FOR_CUSTOMER_SUCCESS_TEAMS = FOR_CUSTOMER_SUCCESS_TEAMS;


//////////////////
// WEBPACK FOOTER
// ./js/constants/StorefrontCollection.js
// module id = 44
// module chunks = 209 210 211 212 213